export const PDF_PAGE_LIST = [
  {
    type: "growth",
    nodeIdCluster: [
      "reportPageCover",
      "reportPageIntroduction",
      "reportPageProposalGrowth",
      "reportPageProposalHowToGet",
      "reportPageProposalDisclosure",
    ],
  },
  {
    type: "growth_income",
    nodeIdCluster: [
      "reportPageCover",
      "reportPageIntroduction",
      "reportPageProposalIncome",
      "reportPageProposalHowToGet",
      "reportPageProposalDisclosure",
    ],
  },
  {
    type: "income",
    nodeIdCluster: [
      "reportPageCover",
      "reportPageIntroduction",
      "reportPageProposalIncome",
      "reportPageProposalHowToGet",
      "reportPageProposalDisclosure",
    ],
  },
];
